import React, { Component } from 'react'
import { SPORT_OTHERS_ID } from '../../../../consts'
import differenceBy from 'lodash.differenceby'
import wrapperClickOutside from '../../../../components/shared/wrapper-click-outside'
import Button from '../../../../front/components/shared/sn-button'
import i18n from '../../../../locales/i18n'

class SelectionBox extends Component {
    render() {
        const {
            selectedSports,
            sports,
            addSportHandle,
            filteredSports,
            onSportSelect,
        } = this.props

        const otherSport = sports.find(sport => (sport.value || sport.id) === SPORT_OTHERS_ID)

        let uniqueSports = differenceBy(filteredSports, selectedSports, sports?.[0]?.value ? 'value' : 'id')

        const doesOtherSportExistsInUniqueSports = uniqueSports.some(sport => (sport.value || sport.id) === SPORT_OTHERS_ID)
        const isOtherSportsAlreadySelected = selectedSports?.some(sport => (sport.value || sport.id) === SPORT_OTHERS_ID)

        if (!doesOtherSportExistsInUniqueSports && !isOtherSportsAlreadySelected) {
            uniqueSports.push(otherSport)
        }

        uniqueSports = uniqueSports.filter(sport => !!sport)

        return (
            <div className="position-relative">
                <div className="position-absolute sport-selection__selection-box w-100">
                    <ul className="list-unstyled sport-selection__selection-box__list">
                        {filteredSports?.length === 0 &&
                            <div className="d-flex align-items-center flex-column">
                                <p className="color-primary mt-3">{i18n.t('sportBox.notFound.title')}</p>
                                {uniqueSports.some(sport => sport.value === SPORT_OTHERS_ID) &&
                                    <p className="text-muted">{i18n.t('sportBox.notFound.text')}</p>
                                }
                            </div>
                        }
                        {uniqueSports.map(sport => (
                            <li
                                key={sport.value || sport.id}
                                className="py-2 pl-3 sport-selection__selection-box__list__item"
                                onClick={() => onSportSelect(sport)}
                            >
                                {sport.label || sport.name}
                            </li>
                        ))}
                        {filteredSports?.length === 0 &&
                            <div className="d-flex justify-content-center mb-3">
                                <Button
                                    className="btn btn-color-gray-light-1 border border-secondary"
                                    onClick={addSportHandle}
                                >
                                    {i18n.t('sportBox.notFound.buttonText')}
                                </Button>
                            </div>
                        }
                    </ul>
                </div>
            </div>
        )
    }
}

export default wrapperClickOutside(SelectionBox, 'showSelectionBlock', 'toggleSelectionBox', false)
